export const PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

const pick = (obj, camelKey, pascalKey) =>
  obj?.[camelKey] ?? obj?.[pascalKey] ?? null;

export const getProcurementTypeLabel = type =>
  PROCUREMENT_TYPE_MAP[type] || type || '-';

export const mapProcurementToImprovementClarificationRow = item => {
  if (!item) return null;

  const productTypeRaw = item.productType ?? item.ProductType;
  const productRaw = productTypeRaw?.product ?? productTypeRaw?.Product;
  const productTypeName = productTypeRaw?.name ?? productTypeRaw?.Name ?? '-';
  const productName = productRaw?.name ?? productRaw?.Name ?? productTypeName;

  return {
    id: pick(item, 'id', 'Id'),
    idProc: pick(item, 'procurementNumber', 'ProcurementNumber'),
    title: pick(item, 'titleProcurement', 'TitleProcurement'),
    procType: getProcurementTypeLabel(
      pick(item, 'procurementType', 'ProcurementType')
    ),
    productType: {
      name: productTypeName,
      product: {
        name: productName,
      },
    },
    description: pick(item, 'description', 'Description'),
    createdDate: pick(item, 'createdDate', 'CreatedDate'),
    updatedDate: pick(item, 'updatedDate', 'UpdatedDate'),
    statusImprovement:
      pick(
        item,
        'statusImprovementProgressLabel',
        'StatusImprovementProgressLabel'
      ) || null,
    statusClarification:
      pick(
        item,
        'statusClarificationProgressLabel',
        'StatusClarificationProgressLabel'
      ) || null,
    statusClarificationProgress: pick(
      item,
      'statusClarificationProgress',
      'StatusClarificationProgress'
    ),
    statusClarificationProgressLabel:
      pick(
        item,
        'statusClarificationProgressLabel',
        'StatusClarificationProgressLabel'
      ) || null,
    unreadResponseCount:
      Number(pick(item, 'unreadResponseCount', 'UnreadResponseCount')) || 0,
    procurementMitraId:
      pick(item, 'procurementMitraId', 'ProcurementMitraId') ??
      pick(item, 'idProcurementMitra', 'IdProcurementMitra') ??
      null,
    idOffer: pick(item, 'idOffer', 'IdOffer'),
  };
};

export const unwrapImprovementClarificationList = result => {
  const payload = result?.data ?? result ?? {};
  const items = payload.items ?? payload.Items ?? [];
  const totalItems = payload.totalItems ?? payload.TotalItems ?? 0;

  return {
    items: items
      .map(mapProcurementToImprovementClarificationRow)
      .filter(Boolean),
    totalItems,
  };
};

export const unwrapImprovementClarificationDetail = response => {
  if (!response) return null;

  const isApiWrapper =
    response.data &&
    response.procurementNumber === undefined &&
    response.ProcurementNumber === undefined &&
    response.titleProcurement === undefined &&
    response.TitleProcurement === undefined;

  const raw = isApiWrapper ? response.data : response;
  const payload =
    raw?.data &&
    raw.procurementNumber === undefined &&
    raw.ProcurementNumber === undefined
      ? raw.data
      : raw;

  return mapProcurementToImprovementClarificationRow(payload);
};

export const IMPROVEMENT_STATUS_META = {
  Open: { color: 'primary' },
  Submitted: { color: 'success' },
  Closing: { color: 'danger' },
};

export const CLARIFICATION_STATUS_META = {
  Open: { color: 'primary' },
  Closing: { color: 'danger' },
  'Closing Clarification': { color: 'danger' },
  'Waiting Response from Dmut': { color: 'warning' },
  'Waiting Response from Panitia Tender': { color: 'warning' },
  'Waiting for Response': { color: 'warning' },
  Waiting: { color: 'warning' },
};

const toPayloadValue = value => {
  if (value === '' || value === undefined) return null;
  return value;
};

export const buildImprovementDyedUndyedPayload = ({
  detailRow,
  kind = 'offer',
  dyed = null,
  undyed = null,
  alpha = null,
}) => {
  void kind;
  const quantityInformationDetailId =
    detailRow?.quantityInformationDetailId ??
    detailRow?.QuantityInformationDetailId ??
    null;

  const entry = {
    quantityInformationDetailId,
    dyed: null,
    undyed: null,
    dyed2: null,
    undyed2: null,
    dyed3: null,
    undyed3: null,
    alpha: null,
    alpha2: null,
    alpha3: null,
    improvementQuantityLocation1: null,
    improvementQuantityLocation2: null,
    improvementQuantityLocation3: null,
    improvementDyed: toPayloadValue(dyed),
    improvementUndyed: toPayloadValue(undyed),
    improvementDyed2: null,
    improvementUndyed2: null,
    improvementDyed3: null,
    improvementUndyed3: null,
    improvementAlpha: toPayloadValue(alpha),
    improvementAlpha2: null,
    improvementAlpha3: null,
  };

  const incotermLocationId =
    detailRow?.incotermLocationId ?? detailRow?.IncotermLocationId ?? null;

  if (incotermLocationId) {
    return {
      listDyedUndyedAlphaFob: [
        {
          ...entry,
          incotermLocationId,
          locationSlot: detailRow?.locationSlot ?? null,
        },
      ],
    };
  }

  return {
    listDyedUndyedAlpha: [entry],
  };
};
